import React from 'react';
import PropTypes from 'prop-types';

const ViewIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString() : '24';
  const h = (height) ? height.toString() : '24';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 24 24"
      width={w}
      height={h}
    >
      <path
                // eslint-disable-next-line max-len
        d="M22.2953 11.2945C22.6999 11.6934 22.6999 12.3066 22.2953 12.7055C21.2973 13.6896 19.7335 15.0889 17.8956 16.2378C16.0472 17.3933 13.9936 18.25 12 18.25C10.0064 18.25 7.95284 17.3933 6.1044 16.2378C4.26651 15.0889 2.70267 13.6896 1.70466 12.7055C1.30012 12.3066 1.30012 11.6934 1.70466 11.2945C2.70267 10.3104 4.26651 8.91115 6.1044 7.76223C7.95284 6.60671 10.0064 5.75 12 5.75C13.9936 5.75 16.0472 6.60671 17.8956 7.76223C19.7335 8.91115 21.2973 10.3104 22.2953 11.2945Z"
        stroke={(fill) || 'black'}
        strokeWidth="1.5"
        fill="none"
      />
      <circle
        cx="12"
        cy="12"
        r="3.25"
        stroke={(fill) || 'black'}
        fill="none"
        strokeWidth="1.5"
      />
    </svg>
  );
};

ViewIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ViewIcon;
